import React from "react";

export const ProjectCheckmarkIcon: React.FC<
  React.SVGProps<SVGSVGElement>
> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    style={{ position: "relative", top: "3px" }}
  >
    <path
      d="M7.05514 9.0605L5.70876 7.71413C5.57158 7.57597 5.40323 7.50688 5.20371 7.50688C5.00418 7.50688 4.82943 7.58186 4.67946 7.73183C4.54199 7.86931 4.47326 8.04245 4.47326 8.25127C4.47326 8.46009 4.54234 8.63358 4.68049 8.77173L6.52469 10.6159C6.66551 10.7568 6.84233 10.8272 7.05514 10.8272C7.26794 10.8272 7.44475 10.7568 7.58558 10.6159L11.3091 6.8884C11.4473 6.75024 11.5164 6.58213 11.5164 6.38405C11.5164 6.18598 11.4417 6.01268 11.2925 5.86413C11.1543 5.72597 10.9808 5.65688 10.772 5.65688C10.5632 5.65688 10.3897 5.72597 10.2515 5.86413L7.05514 9.0605ZM8.00043 14.8022C7.05695 14.8022 6.1717 14.6237 5.34468 14.2669C4.51765 13.91 3.79826 13.4257 3.18649 12.8139C2.57473 12.2022 2.09041 11.4828 1.73354 10.6557C1.37668 9.82873 1.19824 8.94348 1.19824 8C1.19824 7.05652 1.37668 6.17127 1.73354 5.34425C2.09041 4.51723 2.57473 3.79783 3.18649 3.18606C3.79826 2.5743 4.51765 2.08998 5.34468 1.73311C6.1717 1.37625 7.05695 1.19781 8.00043 1.19781C8.9439 1.19781 9.82915 1.37625 10.6562 1.73311C11.4832 2.08998 12.2026 2.5743 12.8144 3.18606C13.4261 3.79783 13.9104 4.51723 14.2673 5.34425C14.6242 6.17127 14.8026 7.05652 14.8026 8C14.8026 8.94348 14.6242 9.82873 14.2673 10.6557C13.9104 11.4828 13.4261 12.2022 12.8144 12.8139C12.2026 13.4257 11.4832 13.91 10.6562 14.2669C9.82915 14.6237 8.9439 14.8022 8.00043 14.8022Z"
      fill="#03AE65"
    />
  </svg>
);
